module.exports = __webpack_public_path__ + "static/media/fs_technology.ff884564.png";